// const enableLogs = false;
const imageCache = {};
const requestDataArray = [];
let inchesToPixels = 10;

const STATUS_SUCCESS = 'success';
const STATUS_FAILURE = 'failed';
const STATUS_STOP_PROCESS = 'stop-process';

const generatePreviewRequestId = () => new Date();

export const renderProject = (renderJsonList, callback) => {
  const requestData = { id: generatePreviewRequestId(), json: renderJsonList };
  requestDataArray.push(requestData);

  if (renderJsonList.length == 0) {
    callback([]);
  } else {
    renderRetry(requestData, callback, 0);
  }
};

const renderRetry = (requestData, callback, retryCount) => {
  const renderJsonList = retryCount > 0 ? requestData : requestData.json;
  const imageList = getImagesToPreload(renderJsonList);
  if (imageList.length == 0) {
    setColorWhenNoImage(renderJsonList, callback);
  }
  const imageData = {
    id: requestData.id,
    images: imageList
  };
  preLoadImages(imageData, status => {
    if (status == STATUS_FAILURE && retryCount < 3) {
      //  debugLog('Try number ' + (retryCount + 1) + ' failed .. Retrying ...');
      renderRetry(renderJsonList, callback, retryCount + 1);
      return;
    }
    if (status == STATUS_STOP_PROCESS) {
      return;
    }

    const returnArray = [];
    for (let j = 0; j < renderJsonList.length; j++) {
      returnArray.push({ image_data: renderWall(renderJsonList[j]) });
      //  debugLog('Rendered wall no.' + (j + 1));
    }
    callback(returnArray);
  });
};

const getImagesToPreload = projectJsonList => {
  const imageList = [];
  for (let j = 0; j < projectJsonList.length; j++) {
    const projectJson = projectJsonList[j];
    for (let i = 0; i < projectJson.layers.length; i++) {
      imageList.push(projectJson.layers[i].image);
    }
    if (
      projectJson.overlay &&
      projectJson.overlay.indexOf('/missing.png') === -1
    ) {
      imageList.push(projectJson.overlay);
    }

    if (
      projectJson.blockChain_qr_code &&
      projectJson.blockChain_qr_code.indexOf('/missing.png') === -1
    ) {
      imageList.push(projectJson.blockChain_qr_code);
    }

    if (
      projectJson.pixelationWarning &&
      projectJson.pixelationWarning.indexOf('/missing.png') === -1
    ) {
      imageList.push(projectJson.pixelationWarning);
    }
  }

  return removeDuplicates(imageList);
};

const createCanvas = renderJson => {
  const canvas = document.createElement('canvas');
  inchesToPixels = inchesToPixelsForDimensions(
    renderJson.width,
    renderJson.height
  );
  canvas.width = renderJson.width * inchesToPixels;
  canvas.height = renderJson.height * inchesToPixels;
  canvas.style.visibility = 'hidden';
  return canvas;
};

const inchesToPixelsForDimensions = (width, height) => {
  const totalArea = width * height;
  const maximumArea = 1000 * 1000;

  return Math.sqrt(
    Math.max(totalArea, maximumArea) / Math.min(totalArea, maximumArea)
  );
};

const renderTiledImage = (context, layer, image, width, height) => {
  const xStart = layer.x * inchesToPixels;
  const yStart = layer.y * inchesToPixels;
  const tileWidth = layer.width * inchesToPixels;
  const tileHeight = layer.height * inchesToPixels;

  let xCoord = xStart;
  let yCoord;
  let xCtr = 0;
  let yCtr = 0;

  if (tileWidth && tileHeight) {
    while (xCoord <= width * inchesToPixels) {
      yCtr = 0;
      yCoord = layer.y * inchesToPixels;

      while (yCoord <= height * inchesToPixels) {
        context.globalAlpha = layer.opacity;
        context.save();

        const initialTranslateX = xCoord + tileWidth * 0.5;
        const initialTranslateY = yCoord + tileHeight * 0.5;
        context.translate(initialTranslateX, initialTranslateY);
        flipContext(context, layer.flip);
        context.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          -(tileWidth * 0.5),
          -(tileHeight * 0.5),
          tileWidth,
          tileHeight
        );
        context.restore();

        yCoord = yCtr * tileHeight + yStart;
        yCtr++;
      }

      xCtr++;
      xCoord = xCtr * tileWidth + xStart;
    }
  }
};

const rotateContext = (context, x, y, angle) => {
  context.translate(x, y);
  context.rotate(angle);
};

const flipContext = (context, flip) => {
  if (flip) {
    context.scale(-1, 1);
  }
};

const renderLayer = (layer, context, parentWidth, parentHeight) => {
  const image = imageCache[layer.image];
  // //  debugLog('Rendering image ... ' + image.src + '  error : ? ' + image.error);

  context.save();

  // tile draws to unrotated context
  if (!layer.tiled) {
    //  debugLog('Not tiled ... angle ' + layer.angle);

    const rotation = (360 - layer.angle) * (Math.PI / 180);
    rotateContext(
      context,
      layer.x * inchesToPixels + layer.width * 0.5 * inchesToPixels,
      layer.y * inchesToPixels + layer.height * 0.5 * inchesToPixels,
      rotation
    );
    flipContext(context, layer.flip);
  }

  if (image && image.width > 0 && image.height > 0) {
    if (layer.tiled) {
      //  debugLog('renderTiledImage .. ');
      renderTiledImage(context, layer, image, parentWidth, parentHeight);
    } else {
      //  debugLog(
      //     'Calling drawImage ...  width :: ' +
      //       image.width +
      //       ' height :: ' +
      //       image.height +
      //       'layer width' +
      //       layer.width +
      //       'layer height ' +
      //       layer.height
      //   );
      context.globalAlpha = layer.opacity;
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        -(layer.width * 0.5 * inchesToPixels),
        -(layer.height * 0.5 * inchesToPixels),
        layer.width * inchesToPixels,
        layer.height * inchesToPixels
      );
    }
  }
  context.restore();
};

const renderWall = renderJson => {
  const canvas = createCanvas(renderJson);
  const context = canvas.getContext('2d');
  const { layers } = renderJson;

  if (renderJson.backgroundColor) {
    context.fillStyle = renderJson.backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);
  } else if (
    renderJson.overlay &&
    renderJson.overlay.indexOf('/missing.png') === -1
  ) {
    const image = imageCache[renderJson.overlay];
    context.drawImage(
      image,
      0,
      0,
      image.width,
      image.height,
      0,
      0,
      canvas.width,
      canvas.height
    );
  } else if (renderJson.color) {
    context.fillStyle = renderJson.color;
    context.fillRect(0, 0, canvas.width, canvas.height);
  }

  for (let i = 0; i < layers.length; i++) {
    const layer = layers[i];
    renderLayer(layer, context, renderJson.width, renderJson.height);
  }

  if (
    renderJson.pixelationWarning &&
    renderJson.pixelationWarning.indexOf('/missing.png') === -1
  ) {
    const image = imageCache[renderJson.pixelationWarning];
    if (image.width !== 0) {
      context.drawImage(
        image,
        0,
        0,
        image.width,
        image.height,
        canvas.width - 80,
        30,
        50,
        50
      );
    }
  }

  if (
    renderJson.blockChain_qr_code &&
    renderJson.blockChain_qr_code.indexOf('/missing.png') === -1
  ) {
    const blockchainImage = imageCache[renderJson.blockChain_qr_code];
    if (blockchainImage.width !== 0) {
      context.drawImage(
        blockchainImage,
        0,
        0,
        blockchainImage.width,
        blockchainImage.height,
        canvas.width - blockchainImage.width - 50,
        canvas.height - blockchainImage.height - 80,
        100,
        100
      );
    }
  }
  return canvas.toDataURL();
};

// const debugLog = aMessage => {
//   if (enableLogs) {
//     console.log(aMessage);
//   }
// };

const setColorWhenNoImage = (projectJsonList, callback) => {
  const returnArray = [];
  for (let j = 0; j < projectJsonList.length; j++) {
    const projectJson = projectJsonList[j];
    if (projectJson.layers.length == 0 && projectJson.color) {
      returnArray.push({ image_data: renderWall(projectJson) });
    }
  }
  if (returnArray.length > 0) {
    callback(returnArray);
  }
};

const removeDuplicates = imageList => {
  const dict = {};
  const outList = [];

  for (let i = 0; i < imageList.length; i++) {
    if (dict[imageList[i]] == undefined || dict[imageList[i]] == null) {
      outList.push(imageList[i]);
      dict[imageList[i]] = true;
    }
  }

  return outList;
};

const preLoadImages = (imageData, callback) => {
  const activeRequestId = imageData.id;
  const imageList = imageData.images;
  let imagesLeft = imageList.length;
  const imageObjects = [];
  let status = STATUS_SUCCESS;

  imageList.forEach((imageListObj, i) => {
    imageObjects.push(document.createElement('img'));
    imageObjects[i].crossOrigin = 'Anonymous';
    imageObjects[i].onload = () => {
      imagesLeft--;
      if (imagesLeft == 0) {
        if (!checkForLatestRequest(activeRequestId)) {
          status = STATUS_STOP_PROCESS;
        }
        callback(status);
      }
    };

    imageObjects[i].onerror = () => {
      status = STATUS_FAILURE;
      imagesLeft--;
      if (imagesLeft == 0) {
        if (!checkForLatestRequest(activeRequestId)) {
          status = STATUS_STOP_PROCESS;
        }
        callback(status);
      }
    };

    imageCache[imageListObj] = imageObjects[i];
    if (imageListObj) {
      imageObjects[i].src = imageListObj;
    }
  });
};

const checkForLatestRequest = currentRequestId => {
  const arrayLength = requestDataArray.length;
  if (arrayLength > 0) {
    if (currentRequestId == requestDataArray[arrayLength - 1].id) {
      requestDataArray.splice(0, arrayLength);
      return true;
    }
    return false;
  }
  return false;
};
